import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { HelperService } from "@shared/services/helper.service";
import { TestEquipmentService } from "@shared/services/test-equipment/test-equipment.service";
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { TEST_EQUIPMENT_CONTEXT_CONSTANT } from "@shared/enums/test-equipment-context.constant";
import { TEST_EQUIPMENT_DEVICE_LIST } from "@shared/enums/test-equipment-device-list.enum";
import { AppConstants } from "@core/constants";
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-test-equipment-page',
  templateUrl: './test-equipment-page.component.html',
  styleUrls: ['./test-equipment-page.component.scss'],
})
export class TestEquipmentPageComponent implements OnInit {
  private sessionService: SessionService = inject(SessionService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private helperService: HelperService = inject(HelperService);
  private testEquipmentService: TestEquipmentService = inject(TestEquipmentService);
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private speedDistanceTypeList: TEST_EQUIPMENT_DEVICE_LIST[] = [
    TEST_EQUIPMENT_DEVICE_LIST.GPS_DEVICE,
    TEST_EQUIPMENT_DEVICE_LIST.POWER_METER,
    TEST_EQUIPMENT_DEVICE_LIST.RUNNING_TREADMILL,
  ];
  private ergometersTypeList: TEST_EQUIPMENT_DEVICE_LIST[] = [
    TEST_EQUIPMENT_DEVICE_LIST.CYCLING_ERGOMETER,
    TEST_EQUIPMENT_DEVICE_LIST.ROWING_ERGOMETER,
    TEST_EQUIPMENT_DEVICE_LIST.SKIING_ERGOMETER,
    TEST_EQUIPMENT_DEVICE_LIST.KAJAK_ERGOMETER,
  ];
  private physiologicalMeasurementsTypeList: TEST_EQUIPMENT_DEVICE_LIST[] = [
    TEST_EQUIPMENT_DEVICE_LIST.VCO2_VO2_ANALYZER,
    TEST_EQUIPMENT_DEVICE_LIST.LACTATE_METER,
  ];

  public testCreationType: any = TEST_EQUIPMENT_CONTEXT_CONSTANT.EQUIPMENT_PAGE;
  public originalDeviceList: any[] = [];
  public filteredDeviceList: any[] = [];
  public speedDistanceDeviceList: any[] = [];
  public ergometersDeviceList: any[] = [];
  public physiologicalMeasurementsDeviceList: any[] = [];
  public payload: any = {
    equipment: [],
  };
  public isDisabled: boolean = true;
  public isExpand: boolean = false;
  public auth: any = {
    first_name: '',
    last_name: '',
    organization: {
      id: null,
      name: '',
    },
  };

  public ngOnInit(): void {
    // Read org details from auth
    this.sessionService.getCurrentUserProfile();
    this.auth = this.sessionService.auth;

    let a: string[] = [];
    this.originalDeviceList = this.helperService.makeCopy(this.activatedRoute.snapshot.data.data);
    this.filteredDeviceList = this.testEquipmentService.getFilteredDeviceList(this.originalDeviceList);
    this.filteredDeviceList.forEach((item: any) => {
      if (!a.includes(item.category)) {
        a.push(item.category);
      }
    });

    this.speedDistanceDeviceList = this.testEquipmentService.getDeviceListByCategoryName(this.filteredDeviceList, this.speedDistanceTypeList, [], this.auth.organization.id);
    this.ergometersDeviceList = this.testEquipmentService.getDeviceListByCategoryName(this.filteredDeviceList, this.ergometersTypeList, [], this.auth.organization.id);
    this.physiologicalMeasurementsDeviceList = this.testEquipmentService.getDeviceListByCategoryName(this.filteredDeviceList, this.physiologicalMeasurementsTypeList, [], this.auth.organization.id);
  }

  public onChangeEquipment(device: any): void {
    this.payload = this.testEquipmentService.generateEquipmentPayload(device, this.payload);

    if (this.payload.equipment.length) {
      this.isDisabled = false;
    }
  }

  public resetEquipmentArray(): void {
    this.payload = undefined;
  }

  public disableSaveButton(): void {
    this.isDisabled = true;
  }

  public save(): void {
    this.payload = this.testEquipmentService.prepareEquipmentDevicePayload(this.payload, this.originalDeviceList);
    this.testEquipmentService.save(this.payload)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.disableSaveButton();
            this.resetEquipmentArray();
            this.snackBar.open('The test equipments have been successfully saved. Reloading...', 'OK', AppConstants.TOAST_CONFIG.SUCCESS);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        },
      })
  }

  public onTabChanged(): void {
    setTimeout(() => {
      this.isExpand = false;
    });
    this.isExpand = true;
  }
}
